<p style="background-color: #E1FFFD; min-height: 60px; min-width: 1150px;">
    backoffice-mini-kpis works!
</p>